import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        searched: '',
        searchedA: '',
        searchedB: '',
    },
    reducers: {
        setSearched: (state, action) => {  //jobschedule
            state.searched = action.payload
        },
        setSearchedA: (state, action) => {  //actionrequired
            state.searchedA = action.payload
        },
        setSearchedB: (state, action) => { //bookingrequired
            state.searchedB = action.payload
        }
    }
    // ,
    // extraReducers: {

    // }
});

export const filterActions = filterSlice.actions;
export const filterThunks = {

}

export default filterSlice.reducer;